interface BurgerIconProps {
    color?: string;
    className?: string;
}

function BurgerIcon({ color = 'currentColor', className = null }: BurgerIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="26px"
            height="26px"
            viewBox="0 0 26 26"
            className={className || undefined}
        >
            <rect x="0" y="7" fill={color} width="26" height="2" />
            <rect x="0" y="14" fill={color} width="26" height="2" />
            <rect x="0" y="21" fill={color} width="26" height="2" />
        </svg>
    );
}

export default BurgerIcon;
